import React from "react";
import { useNavigate } from "react-router-dom";
import { useNavigationSource } from "@/hooks/useNavigationSource";
import LandingPageLayout from "./LandingPageLayout";

interface LandingPageLayoutWithBackProps {
  showGradient?: boolean;
  showFooter?: boolean;
  children?: React.ReactNode;
}

/**
 * Wrapper around LandingPageLayout that provides navigation source-aware back handler
 */
const LandingPageLayoutWithBack: React.FC<LandingPageLayoutWithBackProps> = ({
  showGradient,
  showFooter,
  children,
}) => {
  const navigate = useNavigate();
  const { navigateBackIfExists } = useNavigationSource();

  const handleBack = () => {
    const didNavigate = navigateBackIfExists();
    if (!didNavigate) {
      navigate("/profile/health-profile");
    }
  };

  return (
    <LandingPageLayout
      showGradient={showGradient}
      showFooter={showFooter}
      onBack={handleBack}
    >
      {children}
    </LandingPageLayout>
  );
};

export default LandingPageLayoutWithBack;
